<template>
    <span v-if="this.paymentPreference === 'CONTANTI'">
        {{$t('contanti')}}
    </span>
    <span v-else-if="this.paymentPreference === 'CARTA_CREDITO'">
        {{$t('carrello_pag_carte')}}
    </span>
    <span v-else-if="this.paymentPreference === 'BUONI_PASTO'">
        {{$t('carrello_pag_buoni_pasto')}}
    </span>
</template>

<script>
    export default {
        name: "IncOrderPaymentPreference",
        props: ['paymentPreference']
    }
</script>
